import { Color } from "./colors.js";
const IDEAL_MIN = 45;
const IDEAL_MAX = 55;
const talkRatioCategories = [
  { maxDistance: 0, color: Color.Emerald },
  { maxDistance: 5, color: Color.Green },
  { maxDistance: 10, color: Color.Lime },
  { maxDistance: 15, color: Color.Amber },
  { maxDistance: 20, color: Color.Orange },
  { maxDistance: Infinity, color: Color.Red }
];
const fallbackCategory = {
  maxDistance: Infinity,
  color: Color.Gray
};
function getDistanceFromIdealBand(percentage) {
  if (percentage < IDEAL_MIN) {
    return IDEAL_MIN - percentage;
  }
  if (percentage > IDEAL_MAX) {
    return percentage - IDEAL_MAX;
  }
  return 0;
}
function getTalkRatioColor(ratio) {
  if (!Number.isFinite(ratio)) {
    return fallbackCategory.color;
  }
  const percentage = Math.round(ratio * 100);
  const distance = getDistanceFromIdealBand(percentage);
  return talkRatioCategories.find((c) => distance <= c.maxDistance)?.color ?? fallbackCategory.color;
}
export {
  getTalkRatioColor
};
//# sourceMappingURL=talkRatio.js.map
